import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatListModule } from '@angular/material/list';
import { RouterModule} from '@angular/router';
import { EulaComponent } from '../eula/eula.component';
import { MatDialogModule, MatProgressSpinnerModule} from '@angular/material';
import { MatGridListModule, MatCardModule} from '@angular/material';
import { HomeGridComponent } from './home-grid/home-grid.component';
import {EncryptionKeyService} from '../encryption-key.service';
import { FaqComponent } from '../faq/faq.component';
import { PrivacyStatementComponent } from '../privacy-statement/privacy-statement.component';
import { UnderConstructionComponent } from '../under-construction/under-construction.component';
@NgModule({
  imports: [
    CommonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    FlexLayoutModule,
    MatListModule,
    RouterModule,
    MatDialogModule,
    MatGridListModule,
    MatCardModule,
    MatListModule,
    MatProgressSpinnerModule
  ],
  declarations: [MainComponent, EulaComponent, HomeGridComponent, FaqComponent, PrivacyStatementComponent, UnderConstructionComponent],
  exports: [MainComponent, HomeGridComponent, FaqComponent, PrivacyStatementComponent, UnderConstructionComponent],
  providers: [EncryptionKeyService],
  entryComponents: [EulaComponent]
})
export class MainModule { }



// WEBPACK FOOTER //
// ./src/app/main/main.module.ts